import React, { } from 'react';
import { createBrowserRouter } from "react-router-dom";

import LoginPage from "./pages/auth/features/LoginPage";
import ForgotPasswordPage from './pages/auth/features/ForgotPasswordPage';
import AccountVerificationPage from './pages/auth/features/AccountVerificationPage';
import ResetPasswordPage from './pages/auth/features/ResetPasswordPage';
import AuthProtected from "./pages/auth/AuthProtected";

import Admin from "./pages/admin/Admin";
import AdminProtected from "./pages/admin/AdminProtected";
import Dashboard from "./pages/admin/features/dashboard/Dashboard";
import NotFoundPage from './pages/admin/NotFoundPage';
import SchoolsListPage from './pages/admin/features/schools/school-list/SchoolsListPage';
import PaymentListPage from './pages/admin/features/payments/payment-list/PaymentListPage';



const router = createBrowserRouter([
    {
        path: "/login",
        element:
            <AuthProtected>
                <LoginPage />
            </AuthProtected>,
    },
    {
        path: "/forgot-password",
        element:
            <AuthProtected>
                <ForgotPasswordPage />
            </AuthProtected>,
    },
    {
        path: "/verify-account",
        element:
            <AuthProtected>
                <AccountVerificationPage />
            </AuthProtected>,
    },
    {
        path: "/reset-password",
        element:
            <AuthProtected>
                <ResetPasswordPage />
            </AuthProtected>,
    },

    {
        path: "/",
        element:
            <AdminProtected>
                <Admin />
            </AdminProtected>,
        children: [
            {
                path: "/",
                element: <Dashboard />,
            },
            {
                path: "/schools",
                element: <SchoolsListPage />,
            },
            {
                path: "/payments",
                element: <PaymentListPage />,
            },
            {
                path: "*",
                element: <NotFoundPage />,
            },
        ]
    },
]);


export default router;